// TODO: 주석 필요
export var QUERY_KEYS = {
    TV_BOARD: function (boardType, profileToken, profileName) { return ['board', boardType, profileToken, profileName]; },
    TV_SUB_BOARD: function (subBoardType, subBoardKey, profileToken, profileName, order) {
        return ['subBoard', subBoardType, subBoardKey, profileToken, profileName, order];
    },
    BAND: function (url, parameter, bandId, bandType, profileToken, profileName) {
        return ['band', url, parameter, bandId, bandType, profileToken, profileName];
    },
    TV_BAND: function (bandType, bandId, apiUrl, profileToken, profileName, nextApiUrl, isRefresh) { return ['band', isRefresh, bandType, bandId, apiUrl, profileToken, profileName, nextApiUrl]; },
    DETAIL: function (mediaCode) { return ['detail', mediaCode]; },
    DETAIL_CONTENT_INFO: function (mediaCode, account) { return ['detail', 'contentInfo', mediaCode, account.profileToken]; },
    PLAYER: function (mediaCode, isPreview, account) { return ['player', mediaCode, isPreview, account]; },
    DETAIL_LIST: function (tvingDetailInfo, selectedMenuItemInfo, apiUserToken, isPlayerDetailList) { return ['detail', 'detailList', tvingDetailInfo, selectedMenuItemInfo, apiUserToken, isPlayerDetailList]; },
    ENTRY: function (time) { return ['entry', time]; },
    QR: function (accountReqType) { return ['qr', accountReqType]; },
    ONBOARD: function () { return ['onboard']; },
    EMERGENCY: function (time) { return ['emergency', time]; },
    NOTICE_POPUP: function () { return ['popup']; },
    PROFILE_EDIT: function (profileNo) { return ['profile', 'profileEdit', profileNo]; },
    BILLING_TICKET: function (account, mediaCode) { return ['billingTicket', account, mediaCode]; },
    BILLING_MOBILE_WEB_TICKET: function (account, mediaCode) { return ['billingTicket', 'mobileWeb', account, mediaCode]; },
    BILLING_IN_APP_TICKET: function (account, mediaCode) { return ['billingTicket', 'inApp', account, mediaCode]; },
    ARTICLES: function (articleType, articleCategoryId) { return ['articles', articleType, articleCategoryId]; },
    ARTICLE: function (articleType, articleId) { return ['article', articleType, articleId]; },
    REGISTER: function () { return ['register']; },
    BILLING_HISTORY: function (apiUserToken) { return ['billingHistory', apiUserToken]; },
    SEARCH_BANDS: function (keyword) { return ['searchBands', keyword]; },
    SEARCH_AUTO_RESULT: function (keyword) { return ['searchAutoResult', keyword]; },
    SEARCH_RESULT: function (keyword) { return ['searchResult', keyword]; },
    SEARCH_RECOMMEND: function () { return ['searchRecommend']; },
    PROFILE_LIST: function (apiUserToken) { return ['profileList', apiUserToken]; },
    PROFILE_IMAGE_LIST: function () { return ['profileImageList']; },
    // newTving queryKeys
    PROVISIONING: function (account) { return ['provisioning', account.profileToken]; },
    PROVISIONING_MENU: function (boardType) { return ['provisioningMenu', boardType]; },
    CHECK_ACCESSTOKEN: function (boardType) { return ['checkAccessToken', boardType]; },
};
